"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PropertyCard_1 = __importDefault(require("../PropertyCard"));
const PropertyCardContent_1 = __importDefault(require("../PropertyCard/PropertyCardContent"));
const StyledLink_1 = __importDefault(require("./StyledLink"));
const RelatedPropertiesCardList = ({ relatedProperties, withLinks = false }) => {
    return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: relatedProperties.map((relatedProperty) => {
            const card = ((0, jsx_runtime_1.jsx)(PropertyCard_1.default, { cityName: relatedProperty.cityName, communeName: relatedProperty.communeName, image: relatedProperty.photoCover, surface: relatedProperty.surface, surfaceUnit: relatedProperty.surfaceUnit, chips: relatedProperty.chips, children: (0, jsx_runtime_1.jsx)(PropertyCardContent_1.default, { currency: relatedProperty.principalCurrency, location: relatedProperty.title, pricing: relatedProperty.pricing }) }, relatedProperty.id));
            if (withLinks) {
                return ((0, jsx_runtime_1.jsx)(StyledLink_1.default, { href: relatedProperty.url, target: '_blank', children: card }, `link-${relatedProperty.id}`));
            }
            return card;
        }) }));
};
exports.default = RelatedPropertiesCardList;
//# sourceMappingURL=index.js.map